import { render, staticRenderFns } from "./EtapasIncluirProposta.vue?vue&type=template&id=f5f68c4e&scoped=true"
import script from "./EtapasIncluirProposta.vue?vue&type=script&lang=js"
export * from "./EtapasIncluirProposta.vue?vue&type=script&lang=js"
import style0 from "./EtapasIncluirProposta.vue?vue&type=style&index=0&id=f5f68c4e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f68c4e",
  null
  
)

export default component.exports